import Vue from 'vue';
import FormatterHelper from '@/scripts/helpers/formatter.helper.js'

Vue.filter('FormatDonationStatus', (donationStatus) => {
    return FormatterHelper.formatDonationStatus(donationStatus);
});